import { AuthenticationService } from './../../servicios/authentication.service';
import { Component, OnInit, EventEmitter, ViewChild } from "@angular/core";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";

import {
  Aguas,
  CargosDetallesInput,
  EstadoCuentaInformacionInput,
  RAguasPersonas,
  Medidores,
  Personas
} from "../../entidades/entidades";
import { Observable, empty } from "rxjs";

import { RAguasPersonasService } from "../../servicios/r-aguas-personas.service";
import { AguasService } from "../../servicios/aguas.service";
import { PersonasService } from "../../servicios/personas.service";

@Component({
  selector: 'app-medidores-medicion',
  templateUrl: './medidores-medicion.component.html',
  styleUrls: ['./medidores-medicion.component.css']
})
export class MedidoresMedicionComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  public aguas$: Observable<Aguas>;
  public aguasLimpio: Aguas;
  public idAguasProceso: number;
  medidoresInput: Medidores = new Medidores;
  public medidoresInput$ = new EventEmitter<Medidores>();
  public cargosDetallesInput$ = new EventEmitter<CargosDetallesInput>();

  public estadoCuentaInformacionInput$ = new EventEmitter<EstadoCuentaInformacionInput>();
  catprorrateo: SelectItem[];
  public usuario: any;
  public rAguasPersonas: RAguasPersonas;
  public personas$: Observable<Personas>;
  public edoCuentaInformacion: EstadoCuentaInformacionInput;
  _id_agua: number;
  public progressBar = false ;
  
  constructor(
    private aguasService: AguasService,
    private rAguasPersonasService: RAguasPersonasService,
    private personasService: PersonasService,
  ) { }

  ngOnInit(): void {
  }

  // =====================================================
    //Carga principal
    // =====================================================
    async childAguaBuscaCuentas(idAgua: number) {
      try {
        debugger;
        this.progressBar = true;
        this.idAguasProceso = idAgua;

  
        this.limpiaInput();
        if (!this.idAguasProceso) {
          this.aguas$ = await this.aguasService.getSingle(0);
          this.personas$ = await this.personasService.getSingle(0);
  
          this.limpiaInput();
          return;
        }
  
        // carga formulario de agua
        this.aguas$ = await this.aguasService.getSingle(idAgua);


  
        //Carga formulario de personas
        const rAguasPersonasBusquedas = new RAguasPersonas();
        rAguasPersonasBusquedas.idAgua = idAgua;
        await this.getRAguasPersonas(rAguasPersonasBusquedas);
        this.personas$ = await this.personasService.getSingle(
          this.rAguasPersonas.idPersona
        );
  
        //Carga formulario estado-cuentas
        this.edoCuentaInformacion = new EstadoCuentaInformacionInput();
        this.edoCuentaInformacion.idAgua = idAgua;
        //this.edoCuentaInformacion.cuentaAgua = aguas.cuentaAgua;
        
        let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
        estadoCuentaInformacionInput.idAgua = idAgua;
        //estadoCuentaInformacionInput.cuentaAgua = aguas.cuentaAgua;
        await this.estadoCuentaInformacionInput$.emit(
          estadoCuentaInformacionInput
        );
  
        this._id_agua = idAgua;
        this.medidoresInput = new Medidores();
        this.medidoresInput.idAgua = this._id_agua;
        await this.medidoresInput$.emit(this.medidoresInput);
        //console.log("await this.medidoresInput$.emit(this.medidoresInput);",this.medidoresInput$.emit(this.medidoresInput));
        

      } catch (e) {
        this.muestraMensaje.error(e.message, "top", "center");
        this.progressBar = false;
      } finally {
        console.log("Paso por childAguas");
        this.progressBar = false;
      }
    }

    async getRAguasPersonas(rAguasPersonas: RAguasPersonas) {
      try {
        const datoRetorno = await this.rAguasPersonasService
          .getBusquedas(rAguasPersonas)
          .toPromise();
        this.rAguasPersonas = datoRetorno[0];
      } catch (e) {
        if (e.response) {
          throw { message: e.response.data };
        } else {
          throw e;
        }
      } finally {
        console.log("Paso por getRAguasPersonas");
        this.progressBar = false;
      }
    }

    limpiaInput() {
     /* this.estadoCuentaInformacionInput$.emit(null);
      this.cargosDetallesInput$.emit(null);*/
    }

    async childMedidores(medidor:Medidores)
    {
      try
      {
        debugger;
        await this.estadoCuentaInformacionInput$.emit(null);
        let estadoCuentaInformacionInput = new EstadoCuentaInformacionInput();
        estadoCuentaInformacionInput.idAgua = medidor.idAgua;
  
        await this.estadoCuentaInformacionInput$.emit(
          estadoCuentaInformacionInput
        );
      }catch(e){
        throw e;
    } finally {
      console.log("Paso por childMedidores");
      this.progressBar = false;
    }
    }
  

}
